import { merge } from 'lodash-es';
import axios from '@/axios';
import constants from '@/constants/constants';
import UnknownPrototypeError from '@/errors/UnknownPrototypeError';
import Order from './Order';
import ReturnQuestionnaire from './ReturnQuestionnaire';
import ReturnBasketLine from './ReturnBasketLine';

/**
 * @class
 */
export default class Return
{
    pricing                     = false;
    isMain                      = false; // Is this return is the main or the paired one.

    order                       = null;
    returned_by                 = null;
    id                          = null;
    ide                         = null;
    reference                   = null;
    return_reason_code          = null;
    rdate                       = null;
    price                       = null;
    special_price               = null;
    currency_code               = null;
    price_information           = null;
    price_description           = null;
    status                      = null;
    ecom                        = null;
    icom                        = null;
    user_id                     = null;
    user_app_code               = null;
    position                    = null;
    return_questionnaire        = null;

    // ------------------------------------------------------------------------- CONSTRUCTOR

    constructor(order, attributes = {})
    {
        this.order = order;
        this.returned_by = order.order_by;
        this.return_questionnaire = new ReturnQuestionnaire(this.returned_by, this.order.article.return_questionnaire_code);

        if(attributes)
        {
            this.setAttributes(attributes);
        }
    }

    //-------------------------------------------------------------------------- ATTRIBUTES

    setAttributes(attributes)
    {
        for(const key in attributes)
        {
            if(this[key] !== undefined && ['order', 'returned_by', 'return_questionnaire'].indexOf(key) == -1)
            {
                this[key] = attributes[key];
            }
            else if(key == 'return_questionnaire_answers')
            {
                // @todo
            }
        }
    }

    //-------------------------------------------------------------------------- RETURN QUESTIONNAIRE

    getReturnQuestionnaire()
    {
        return this.return_questionnaire;
    }

    //-------------------------------------------------------------------------- ORDER

    getOrder()
    {
        return this.order;
    }

    //-------------------------------------------------------------------------- TEMPLATE

    template(isInitialTemplate = false)
    {
        const initValues = null;
        const additionalValues = {};

        const returnQuestionnaire = this.getReturnQuestionnaire();

        return returnQuestionnaire.template(initValues, additionalValues).then(response =>
        {
            /*
             * Set values like :
             * - return_reason_code
             * - rdate
             */
            this.setAttributes(returnQuestionnaire.getValues());

            return Promise.resolve(response);
        });
    }

    //-------------------------------------------------------------------------- PRICE

    resetPrice()
    {
        this.setAttributes({
            price:             null,
            price_information: null,
            price_description: null,
        });
    }

    fetchPrice()
    {
        console.log('Pricing start');

        // Set "validating" status
        this.pricing = true;

        // Build URL
        const url = ('/api/return/price/:eid')
            .replace(':eid', this.returned_by);

        // Get parameter values.
        const data = {
            returns: [this.toApi()],
            options: {},
        };

        return axios.post(url, data)
            .then(response =>
            {
                console.log('Pricing: response from CS Orders:', response.data);

                this.setAttributes(response.data[0]);

                return Promise.resolve(response);
            })
            .catch(error =>
            {
                console.log('Pricing error', error);

                this.resetPrice();

                return Promise.reject(error);
            })
            .finally(() =>
            {
                this.pricing = false;
            });
    }

    // ------------------------------------------------------------------------- BASKET LINE

    toReturnBasketLine()
    {
        const returnBasketLine = new ReturnBasketLine({
            id:              this.return_basket_line_id,
            order_reference: this.order.reference,
            special_price:   this.special_price,
            returned_by:     this.returned_by,
            ecom:            this.ecom,
            icom:            this.icom,
        });

        this.return_questionnaire.getParameters().forEach((parameter, key) =>
        {
            const value = parameter.getValue();

            switch(parameter.data_section)
            {
                case 'return_question':
                    returnBasketLine.setReturnQuestionnaireAnswersAttribute(key, value);
                    break;

                case 'NATIVE':
                    returnBasketLine[key] = value;
                    break;
            }
        });

        console.log('Return to return basket line', this, returnBasketLine);

        return returnBasketLine;
    }

    //-------------------------------------------------------------------------- API

    toApi()
    {
        const apiReturn = {
            id:                           this.id,
            ide:                          this.ide,
            reference:                    this.reference,
            return_reason_code:           this.return_reason_code,
            rdate:                        this.rdate,
            price:                        this.price,
            special_price:                this.special_price,
            currency_code:                this.currency_code,
            ecom:                         this.ecom,
            icom:                         this.icom,
            user_id:                      this.user_id,
            user_app_code:                this.user_app_code,
            order_reference:              this.order.reference,
            position:                     this.position,
            return_questionnaire_answers: [],
        };

        const parameters = this.getReturnQuestionnaire().getParameters();

        parameters.forEach((parameter, code) =>
        {
            if(parameter.data_section == 'return_question')
            {
                apiReturn.return_questionnaire_answers.push({
                    question_code: code,
                    answer:        parameter.getValue(),
                });
            }
        });

        return apiReturn;
    }
}
